module.exports = __webpack_public_path__ + "img/docx-icon.389255b.svg?v=1764327952164";